'use client';

import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import Link from 'next/link';
import React, { useEffect, useState } from 'react';
import { Chevron, ChevronUp } from '@shared/ui-components/svgs';
import { type LinkBlock, type QuickLinksBlock as QuickLinksBlockData } from '../../utils/data/graphql/_generated/gql-generated';
import { QuickLinksBlockTheme } from './utils/quick-links-block-themes';
import styles from './quick-links-block.module.scss';
export type QuickLinksBlockProps = {
  blockData: QuickLinksBlockData;
  id?: Nullable<string>;
};
export const QuickLinksBlock = t0 => {
  const $ = _c(41);
  const {
    blockData,
    id
  } = t0;
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [isMobileExpanded, setIsMobileExpanded] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const linksContainer = document.querySelector(`.${styles["quick-links-block__links"]}`);
      if (linksContainer) {
        setIsOverflowing(linksContainer.scrollWidth > linksContainer.clientWidth);
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleResize = t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      handleResize();
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    };
    t3 = [];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  const handleScroll = _temp;
  const t4 = blockData.Color === QuickLinksBlockTheme.Blue;
  const t5 = blockData.Color === QuickLinksBlockTheme.Gold;
  let t6;
  if ($[3] !== t4 || $[4] !== t5) {
    t6 = classNames(styles["quick-links-block"], {
      [styles["quick-links-block--blue"]]: t4,
      [styles["quick-links-block--gold"]]: t5
    });
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== id) {
    t7 = id && {
      id
    };
    $[6] = id;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = blockData.QuickLinksLabel ?? "Quick Links:";
  let t9;
  if ($[8] !== t8) {
    t9 = <span>{t8}</span>;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== isMobileExpanded) {
    t10 = classNames(styles["quick-links-block__button"], styles["quick-links-block__toggle-expand"], {
      [styles["quick-links-block__toggle-expand--active"]]: isMobileExpanded
    });
    $[10] = isMobileExpanded;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== isMobileExpanded) {
    t11 = () => setIsMobileExpanded(!isMobileExpanded);
    $[12] = isMobileExpanded;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <ChevronUp />;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== t10 || $[16] !== t11) {
    t13 = <button className={t10} onClick={t11}>{t12}</button>;
    $[15] = t10;
    $[16] = t11;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t13 || $[19] !== t9) {
    t14 = <p className={styles["quick-links-block__label"]}>{t9}{t13}</p>;
    $[18] = t13;
    $[19] = t9;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== isMobileExpanded) {
    t15 = classNames(styles["quick-links-block__links-container"], {
      [styles["quick-links-block__links-container--mobile-expanded"]]: isMobileExpanded
    });
    $[21] = isMobileExpanded;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== isOverflowing) {
    t16 = isOverflowing && <button className={classNames(styles["quick-links-block__prev"], styles["quick-links-block__button"])} onClick={() => handleScroll("left")}><Chevron /></button>;
    $[23] = isOverflowing;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== blockData.QuickLinks) {
    t17 = blockData.QuickLinks?.map(_temp2);
    $[25] = blockData.QuickLinks;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t17) {
    t18 = <div className={styles["quick-links-block__links"]}>{t17}</div>;
    $[27] = t17;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== isOverflowing) {
    t19 = isOverflowing && <button className={classNames(styles["quick-links-block__next"], styles["quick-links-block__button"])} onClick={() => handleScroll("right")}><Chevron /></button>;
    $[29] = isOverflowing;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== t15 || $[32] !== t16 || $[33] !== t18 || $[34] !== t19) {
    t20 = <div className={t15}>{t16}{t18}{t19}</div>;
    $[31] = t15;
    $[32] = t16;
    $[33] = t18;
    $[34] = t19;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== t14 || $[37] !== t20 || $[38] !== t6 || $[39] !== t7) {
    t21 = <section className={t6} {...t7}>{t14}{t20}</section>;
    $[36] = t14;
    $[37] = t20;
    $[38] = t6;
    $[39] = t7;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  return t21;
};
function _temp(direction) {
  const linksContainer_0 = document.querySelector(`.${styles["quick-links-block__links"]}`);
  if (linksContainer_0) {
    const scrollAmount = direction === "left" ? -linksContainer_0.clientWidth : linksContainer_0.clientWidth;
    linksContainer_0.scrollBy({
      behavior: "smooth",
      left: scrollAmount
    });
  }
}
function _temp2(link) {
  return <React.Fragment key={link?.ContentLink?.Id}><Link className={classNames(styles["quick-links-block__link"], styles["quick-links-block__button"])} href={(link?.ContentLink?.Expanded as LinkBlock)?.LinkToContent ?? "#"}>{(link?.ContentLink?.Expanded as LinkBlock)?.DisplayText}</Link><span className={styles["quick-links-block__separator"]}>{"\u2022"}</span></React.Fragment>;
}